/**
 * GovSecretarias — mapa das secretarias municipais com SLA e responsável.
 *
 * v0.99.9 · Wave 3 · Fev/2026 — módulo GOV puro (não existe no privado).
 */
import { Buildings, Clock, User } from "@phosphor-icons/react";

// Base pré-cadastrada de secretarias padrão brasileiras.
// Em produção esses dados vêm do backend cadastrado pelo órgão.
const DEFAULTS = [
  { code: "administracao", name: "Administração", responsible: "Sec. de Administração", sla_hours: 24 },
  { code: "saude", name: "Saúde", responsible: "Sec. de Saúde", sla_hours: 8 },
  { code: "educacao", name: "Educação", responsible: "Sec. de Educação", sla_hours: 48 },
  { code: "obras", name: "Obras e Infraestrutura", responsible: "Sec. de Obras", sla_hours: 72 },
  { code: "assistencia_social", name: "Assistência Social", responsible: "Sec. Assistência Social", sla_hours: 12 },
  { code: "fazenda", name: "Fazenda e Tributos", responsible: "Sec. da Fazenda", sla_hours: 48 },
  { code: "meio_ambiente", name: "Meio Ambiente", responsible: "Sec. do Meio Ambiente", sla_hours: 72 },
  { code: "procuradoria", name: "Procuradoria Jurídica", responsible: "Procuradoria Geral", sla_hours: 120 },
  { code: "rh", name: "Recursos Humanos", responsible: "Sec. de RH", sla_hours: 48 },
  { code: "gabinete", name: "Gabinete", responsible: "Gabinete do Prefeito", sla_hours: 24 },
  { code: "cultura", name: "Cultura, Esporte e Turismo", responsible: "Sec. Cultura/Esporte", sla_hours: 72 },
  { code: "seguranca", name: "Segurança e Trânsito", responsible: "Sec. de Segurança", sla_hours: 6 },
  { code: "ouvidoria", name: "Ouvidoria", responsible: "Ouvidoria Municipal", sla_hours: 24 },
];

export default function GovSecretarias() {
  return (
    <div data-testid="gov-secretarias-page">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-[0.22em] text-emerald-700/70 font-medium mb-1">Configurações</div>
        <h1 className="font-heading text-2xl font-semibold text-slate-900 tracking-tight flex items-center gap-2">
          <Buildings size={22} className="text-emerald-700" />
          Secretarias & SLA
        </h1>
        <p className="text-[12.5px] text-slate-500 mt-0.5">
          Mapa dos departamentos do órgão · SLA de resposta por secretaria · responsáveis.
        </p>
      </div>
      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        {DEFAULTS.map((s) => (
          <div key={s.code} data-testid={`sec-card-${s.code}`} className="rounded-xl border border-slate-200 bg-white p-4 hover:border-emerald-300 transition-colors">
            <div className="flex items-start justify-between mb-2">
              <div className="font-heading font-semibold text-slate-900 text-[14px]">{s.name}</div>
              <span className="inline-flex items-center gap-1 text-[10px] font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5 rounded">
                <Clock size={10} weight="bold" /> {s.sla_hours}h
              </span>
            </div>
            <div className="text-[11.5px] text-slate-500 flex items-center gap-1 mt-1">
              <User size={11} /> {s.responsible}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 text-[11.5px] text-slate-500 italic">
        Estas são as secretarias padrão sugeridas para prefeituras brasileiras. Em breve você poderá adicionar/editar diretamente por aqui.
      </div>
    </div>
  );
}
